module.exports = __webpack_public_path__ + "static/media/6674c227.jpg";